class BESSAppContactModal extends BESSAppModal {

    constructor() {
        super('app-contact-modal');
        if (this.view.node.length === 0) return;

        this.view.node.find('select')
            .addClass('form-select')
            .removeClass('form-control');

        let onChange = this.#updateState.bind(this);
        this.controls = null
        this.submitButton = this.view.node.find('.app-submit');
        this.controls = {
            council: getMaterialTextControl('council'),
            project: getMaterialTextControl('project'),
            name: getMaterialTextControl('name'),
            email: getMaterialTextControl('email'),
            message: getMaterialTextControl('message', onChange),
        }
        onChange();

        this.form = this.view.node.find('form');
        this.form.submit(this.#onSubmit.bind(this));
    }

    #updateState() {
        if (this.controls == null || this.controls.message.length === 0) return;
        this.submitButton.enableIf(
            this.controls.message.val().length > 3
        );
    }

    #onSubmit(e) {
        e.preventDefault();
        this.close();

        BESSApp.instance.services.api.sendContact(this.form.serialize(), this.#onContactDone.bind(this));
    }

    #onContactDone() {
        this.informUser("Contact", "Thanks, your message has been sent to the BESS Help Desk who will be in touch.")
    }
}